"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";

export const imageGalleryTopicDefaultValue = {
  topRightImageDesktop: "https://picsum.photos/559/315",
  topRightImageTablet: null,
  topRightImageMobile: null,
  bottomLeftImageDesktop: "https://picsum.photos/559/315",
  bottomLeftImageTablet: null,
  bottomLeftImageMobile: null,
  title: "Lorem ipsum",
  subtitle: "Lorem ipsum subtitelum",
  descriptiveText:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  ctaText: "Learn more",
  ctaLink: "/",
};

export const imageGalleryTopicInputs = [
  {
    name: "data",
    type: "object",
    subFields: [
      {
        name: "topRightImageDesktop",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        helperText:
          "Desktop version of the top right image (Recommended: high resolution)",
        required: true,
      },
      {
        name: "topRightImageTablet",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        helperText:
          "Tablet version of the top right image (Recommended: medium resolution)",
        required: false,
      },
      {
        name: "topRightImageMobile",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        helperText:
          "Mobile version of the top right image (Recommended: smaller resolution)",
        required: false,
      },
      {
        name: "bottomLeftImageDesktop",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        helperText:
          "Desktop version of the bottom left image (Recommended: high resolution)",
        required: true,
      },
      {
        name: "bottomLeftImageTablet",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        helperText:
          "Tablet version of the bottom left image (Recommended: medium resolution)",
        required: false,
      },
      {
        name: "bottomLeftImageMobile",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        helperText:
          "Mobile version of the bottom left image (Recommended: smaller resolution)",
        required: false,
      },
      {
        name: "title",
        type: "richText",
        helperText: "Main title of the gallery",
        required: true,
      },
      {
        name: "subtitle",
        type: "richText",
        helperText: "Subtitle of the gallery",
        required: true,
      },
      {
        name: "descriptiveText",
        type: "richText",
        helperText: "Detailed description text",
        required: true,
      },
      {
        name: "ctaText",
        type: "string",
        helperText: "Call to action button text",
        required: true,
      },
      {
        name: "ctaLink",
        type: "string",
        helperText: "Call to action button link URL",
        required: true,
      },
    ],
    defaultValue: imageGalleryTopicDefaultValue,
  },
  {
    name: "mode",
    type: "string",
    defaultValue: "light",
    enum: ["dark", "light"],
    helperText: "Choose between dark and light mode",
  },
  {
    name: "rtl",
    type: "boolean",
    defaultValue: false,
    helperText: "Enable right-to-left layout",
  },
] as const satisfies Inputs;

export const ImageTopicGalleryTopicComponent: RegisteredComponent = {
  name: "ImageGalleryTopic",
  component: dynamic(
    async () => (await import("./ImageGalleryTopic")).ImageGalleryTopic
  ),
  canHaveChildren: false,
  inputs: imageGalleryTopicInputs,
};
